module.exports = __webpack_public_path__ + "img/my-ricoma.902bf935.svg";